import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { flip, FloatingPortal, offset, shift, useFloating, useHover, useInteractions } from '@floating-ui/react';
import clsx from 'clsx';
import { marked } from 'marked';
import React, { useCallback, useState } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Tooltip = _ref => {
  let {
    placement,
    content = '',
    className = '',
    tooltipClassName = '',
    allowEventPropagation = false,
    children
  } = _ref;
  const htmlContent = marked.parseInline(content); // Prevent tooltip clicks
  // from propagating to parent labels
  // and interacting with form fields

  const stopPropagation = useCallback(evt => {
    if (allowEventPropagation) return;

    if (evt) {
      evt.stopPropagation();
      evt.preventDefault();
    }
  }, [allowEventPropagation]);
  return /*#__PURE__*/_jsxs("span", {
    className: clsx(styles.container, ...className.split(' ')),
    tabIndex: -1,
    onClick: stopPropagation,
    children: [children, /*#__PURE__*/_jsx("span", {
      className: clsx(styles.tooltip, styles[`tooltip--${placement}`], tooltipClassName),
      dangerouslySetInnerHTML: {
        __html: htmlContent
      }
    })]
  });
};

export const TooltipV2 = _ref2 => {
  let {
    placement,
    content = '',
    className = '',
    tooltipClassName = '',
    children
  } = _ref2;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    placement,
    open: isOpen,
    onOpenChange: setIsOpen,
    middleware: [offset(4), flip(), shift()]
  });
  const hover = useHover(context);
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([hover]);
  const htmlContent = marked.parseInline(content);
  return /*#__PURE__*/_jsxs("span", _objectSpread(_objectSpread({
    ref: refs.setReference,
    className: clsx(styles.container, ...className.split(' ')),
    tabIndex: -1
  }, getReferenceProps()), {}, {
    children: [children, isOpen && /*#__PURE__*/_jsx(FloatingPortal, {
      children: /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
        ref: refs.setFloating,
        className: clsx(styles.tooltip, styles.tooltipV2, tooltipClassName),
        style: floatingStyles
      }, getFloatingProps()), {}, {
        dangerouslySetInnerHTML: {
          __html: htmlContent
        }
      }))
    })]
  }));
};
export default Tooltip;